"use client";
import React from 'react';
// import { NewBadge } from '../../webapp/src/components/NewBadge';
// import { GerBadge, PerBadge } from '../../webapp/src/components/GerPerBadges';
// import { WebsiteBadge } from '../../webapp/src/components/WebsiteBadge';
// import { FacultyBadge } from '../../webapp/src/components/FacultyBadge';
// import { InterviewBadge } from '../../webapp/src/components/InterviewBadge';
// import { ScoreBadge } from '../../webapp/src/components/ScoreBadge';
// import type { ScoreTriple } from '../../webapp/src/calculator/calculator';
import { NewBadge } from './NewBadge';
import { QuotaBadge } from "./QuotaBadge";

import { GerBadge, PerBadge } from './GerPerBadges';
import { WebsiteBadge } from './WebsiteBadge';
import { FacultyBadge } from './FacultyBadge';
import { InterviewBadge } from './InterviewBadge';
import { ScoreBadge } from './ScoreBadge';
import type { ScoreTriple } from '../calculator/calculator';
import { buildRelativeUrl } from '../utils/urlUtils';
import { MERResult } from '../types';


interface BadgeBarProps {
  prog_data: any;
  inst_data: any;
  ger?: MERResult;
  per?: MERResult;
  translate: (key: string) => string;
  userScores?: Record<string, ScoreTriple>;
  activeSubjects?: string[];
  programmes: any[];
}

export const BadgeBar: React.FC<BadgeBarProps> = ({
  prog_data,
  inst_data,
  ger,
  per,
  translate,
  userScores,
  activeSubjects,
  programmes
}) => {

  var weightsUrl = inst_data?.urls.weights || inst_data?.urls.specified_apl_subjects || prog_data?.urls?.weights;
  weightsUrl = weightsUrl?.replace('(jupas_id)', prog_data?.jupas_id);
  // const weightsUrl = prog_data?.urls?.weights || inst_data?.urls?.weights || inst_data?.urls?.specified_apl_subjects;

  // debugger;
  return (
    
    <div className="flex items-center gap-2 flex-wrap">
      <NewBadge newProgramme={prog_data.new_programme} />
      
      <GerBadge ger={ger} translate={translate} />
      
      <PerBadge per={per} translate={translate} />

      <FacultyBadge faculty_eng={prog_data?.faculty_eng} faculty_tch={prog_data?.faculty_tch} />
      
      <InterviewBadge interview_eng={prog_data?.interview_eng} interview_tch={prog_data?.interview_tch} />

      <ScoreBadge
        jupas_id={prog_data.jupas_id}
        userScores={userScores || {}}
        activeSubjects={activeSubjects}
        programs={programmes}
        ger={ger}
        per={per}
      />

      <QuotaBadge quota={prog_data?.first_year_intake} />

      {/* JUPAS webpage for the programme*/}
      <WebsiteBadge
        url={inst_data?.urls?.admission_page}
        label="Admission Page"
        colorClass="bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100"
      />

      {/* JUPAS webpage for the programme*/}
      <WebsiteBadge
        url={prog_data?.urls?.jupas_page}
        label="Jupas Page"
        colorClass="bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100"
      />

      {/* JUPAS PDF for the institution */}
      {/* For SSSDP programmes (prefix starts with 'S'), use 'S.pdf' since all SSSDP share one PDF */}
      {(inst_data?.urls?.jupas_pdf || (inst_data?.inst_prefix?.startsWith('S') && inst_data?.inst_prefix !== 'S')) && (
        <WebsiteBadge
          url={buildRelativeUrl('jupas_pdfs', `${inst_data?.inst_prefix?.startsWith('S') ? inst_data.inst_prefix.substring(0, 2) : inst_data.inst_prefix}.pdf`)}
          label="Jupas PDF"
          colorClass="bg-indigo-50 text-indigo-700 border border-indigo-200 hover:bg-indigo-100"
        />
      )}

      {/* PROGRAMME URLS */}
      {prog_data?.urls?.programme && Array.isArray(prog_data.urls.programme) && prog_data.urls.programme.map((url: string, index: number) => (
        <WebsiteBadge
          key={`programme-${index}`}
          url={url}
          label={prog_data.urls.programme && prog_data.urls.programme.length > 1 ? `Programme ${index + 1}` : "Programme"}
          colorClass="bg-indigo-50 text-indigo-700 border border-indigo-200 hover:bg-indigo-100"
        />
      ))}

      {/* Institutional or Programme-specific weights URL */}
      <WebsiteBadge
        url={weightsUrl}
        label="Weights"
        colorClass="bg-sky-50 text-sky-700 border border-sky-200 hover:bg-sky-100"
      />
      
      <WebsiteBadge
        url={inst_data?.urls?.calculator}
        label="Calculator"
        colorClass="bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100"
      />

      <WebsiteBadge
        url={inst_data?.urls?.inst_page || prog_data?.urls?.inst_page}
        label="Inst. Page"
        colorClass="bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100"
      />

      <WebsiteBadge
        url={prog_data?.urls?.sapl_pdf || inst_data?.urls?.sapl_pdf}
        label="SAPL"
        colorClass="bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100"
      />

      <WebsiteBadge
        url={prog_data?.urls?.sixth_subject_bonus || inst_data?.urls?.sixth_subject_bonus}
        label="6th Subject Bonus"
        colorClass="bg-violet-50 text-violet-700 border border-violet-200 hover:bg-violet-100"
      />


    </div>
  );
};
